import { CountryConfig } from "../../shared/types";
import { indiaFormRegistry } from "./formRegistry";
import { ReactComponent as IndiaFlag } from "../../assets/india-flag.svg";
import { PURPOSE_DESCRIPTION_OPTIONS } from "../../shared/const";

export const indiaConfig: CountryConfig = {
  code: "INR",
  name: "India",
  flag: IndiaFlag,
  currencyCode: "INR",
  formRegistry: indiaFormRegistry,
  paymentMethods: [{ name: "Bank Transfer", value: "bank_transfer" }],
  paymentPurposes: PURPOSE_DESCRIPTION_OPTIONS,
  steps: [
    {
      id: "amount",
      type: "amount",
      title: "Amount",
      stepTitle: "How much are you sending?",
    },
    {
      id: "beneficiary",
      type: "beneficiary",
      title: "Beneficiary",
      stepTitle: "Beneficiary details",
    },
    {
      id: "review",
      type: "review",
      title: "Review",
      stepTitle: "Review the details of your transaction",
    },
  ],
};
